export default {
    XSRF_TOKEN: 'XSRF-TOKEN'
}
